import API from "./api";
import * as routes from './_routes';

export function fetchOffice(officeId) {
    return API.get(routes.GET_OFIICE + officeId);
}
